// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  /* Removed overflow: hidden to avoid interfering with drag-and-drop */
}

/* Loading animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Loading spinner classes for ProtectedRoute */
.loading-spinner-outer {
  position: absolute;
  width: 120px;
  height: 120px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top: 3px solid #007BFF;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  transition: none !important;
}

.loading-spinner-inner {
  position: absolute;
  width: 90px;
  height: 90px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-top: 2px solid #4a9eff;
  border-radius: 50%;
  animation: spin 1.5s linear infinite reverse;
  transition: none !important;
}

.loading-logo-container {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.loading-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #252525;
  /* Default background - will be overridden by JavaScript */
  /* background-image: url('../public/background9.png'); */
  background-size: 760px 760px; /* Tile size for repeating pattern */
  background-repeat: repeat; /* Enable tiling of the background image */
  background-attachment: local; /* Background scrolls WITH content - infinite pinboard effect */
  position: relative;
}

/* Dark overlay to make content readable on any background */
body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* 60% dark overlay */
  z-index: -1;
  pointer-events: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Make bucket titles unselectable */
h3 {
  -webkit-user-select: none;
          user-select: none;
}

/* Make the "Add Ticket" button text unselectable */
button {
  -webkit-user-select: none;
          user-select: none;
}

/* Define a global hover effect with smooth transition */
button:hover:not(.bucket-nav-button), .button:hover {
  background-color: #3a3d42; /* Hover background color */
  color: #ffffff; /* Hover text color */
  transition: background-color 0.4s ease, color 0.4s ease; /* Smooth fade-in effect */
}

/* Updated hover effect for the "Löschen" button to use a darker red */
button.deleteButton:hover, .deleteButton:hover {
  background-color: #8b0000; /* Darker red for hover */
  color: #ffffff; /* Keep text white */
  transition: background-color 0.3s ease, color 0.3s ease; /* Smooth fade-in and fade-out effect */
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,qEAAqE;AACvE;;AAEA,sBAAsB;AACtB;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,0DAA0D;EAC1D,wDAAwD;EACxD,4BAA4B,EAAE,oCAAoC;EAClE,yBAAyB,EAAE,0CAA0C;EACrE,4BAA4B,EAAE,+DAA+D;EAC7F,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,qBAAqB;EACrD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE;aACW;AACb;;AAEA,oCAAoC;AACpC;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB,EAAE,2BAA2B;EACtD,cAAc,EAAE,qBAAqB;EACrC,uDAAuD,EAAE,0BAA0B;AACrF;;AAEA,sEAAsE;AACtE;EACE,yBAAyB,EAAE,yBAAyB;EACpD,cAAc,EAAE,oBAAoB;EACpC,uDAAuD,EAAE,uCAAuC;AAClG","sourcesContent":["html, body, #root {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  /* Removed overflow: hidden to avoid interfering with drag-and-drop */\r\n}\r\n\r\n/* Loading animation */\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Loading spinner classes for ProtectedRoute */\r\n.loading-spinner-outer {\r\n  position: absolute;\r\n  width: 120px;\r\n  height: 120px;\r\n  border: 3px solid rgba(255, 255, 255, 0.1);\r\n  border-top: 3px solid #007BFF;\r\n  border-radius: 50%;\r\n  animation: spin 2s linear infinite;\r\n  transition: none !important;\r\n}\r\n\r\n.loading-spinner-inner {\r\n  position: absolute;\r\n  width: 90px;\r\n  height: 90px;\r\n  border: 2px solid rgba(255, 255, 255, 0.1);\r\n  border-top: 2px solid #4a9eff;\r\n  border-radius: 50%;\r\n  animation: spin 1.5s linear infinite reverse;\r\n  transition: none !important;\r\n}\r\n\r\n.loading-logo-container {\r\n  width: 70px;\r\n  height: 70px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10;\r\n}\r\n\r\n.loading-logo {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #252525;\r\n  /* Default background - will be overridden by JavaScript */\r\n  /* background-image: url('../public/background9.png'); */\r\n  background-size: 760px 760px; /* Tile size for repeating pattern */\r\n  background-repeat: repeat; /* Enable tiling of the background image */\r\n  background-attachment: local; /* Background scrolls WITH content - infinite pinboard effect */\r\n  position: relative;\r\n}\r\n\r\n/* Dark overlay to make content readable on any background */\r\nbody::before {\r\n  content: '';\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.6); /* 60% dark overlay */\r\n  z-index: -1;\r\n  pointer-events: none;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Make bucket titles unselectable */\r\nh3 {\r\n  user-select: none;\r\n}\r\n\r\n/* Make the \"Add Ticket\" button text unselectable */\r\nbutton {\r\n  user-select: none;\r\n}\r\n\r\n/* Define a global hover effect with smooth transition */\r\nbutton:hover:not(.bucket-nav-button), .button:hover {\r\n  background-color: #3a3d42; /* Hover background color */\r\n  color: #ffffff; /* Hover text color */\r\n  transition: background-color 0.4s ease, color 0.4s ease; /* Smooth fade-in effect */\r\n}\r\n\r\n/* Updated hover effect for the \"Löschen\" button to use a darker red */\r\nbutton.deleteButton:hover, .deleteButton:hover {\r\n  background-color: #8b0000; /* Darker red for hover */\r\n  color: #ffffff; /* Keep text white */\r\n  transition: background-color 0.3s ease, color 0.3s ease; /* Smooth fade-in and fade-out effect */\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
